<ul class="errors"
    *ngIf="errorList.length">
  <li class="error">
    {{ errorList[0] | translate }} <!-- Displaying only the first error in the array -->
  </li>
</ul>
